import React from 'react';

const Quadrant = props => (
  <div id="quadrant" />
)

export default Quadrant;



// WEBPACK FOOTER //
// ./src/components/Quadrant.js